// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		$(".arrow-home").click(function(e){
			$("body, html").animate({
				scrollTop: $(window).height()
			},800)
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		$(".arrow-home").click(function(e){
			$("body, html").animate({
				scrollTop: $(window).height()
			},800)
		});

		/* Hamburger Menu on Vanilla */
		var hambBtn = document.getElementById('burgerMenu');
		var hambMenu = document.getElementById('primary-nav');
		hambBtn.onclick = function(){
			if( hambMenu.offsetWidth > 0 && hambMenu.offsetHeight > 0 ){
				hambMenu.classList.remove("opened");
				hambBtn.classList.remove("active");
				console.log('abierto, debe cerrar...');
			}else{
				console.log('cerrado, debe abrir...');
				hambMenu.classList.add("opened");
				hambBtn.classList.add("active");
			}
		}

		/* Inset custom slick arrows */
		$('.custom-slick-prev').on('click', function(e){
			e.preventDefault();
			$(this).closest('.sym-slides').slick('slickPrev');
		});
		$('.custom-slick-next').on('click', function(e){
			e.preventDefault();
			$(this).closest('.sym-slides').slick('slickNext');
		});

		//booking CTA
		document.getElementById('bookinCta').addEventListener('click', function(){
			document.getElementById('bookingBlock').classList.add('open');
		});
		document.getElementById('closeBooking').addEventListener('click', function(){
			document.getElementById('bookingBlock').classList.remove('open');
		});
		document.getElementById('closeBooking2').addEventListener('click', function(){
			document.getElementById('bookingBlock').classList.remove('open');
		});

		// Moving Labels
		var formInputs = document.querySelectorAll('#frmContact .form-entry input, #frmContact .form-entry textarea');
		Array.prototype.forEach.call(formInputs, function(elements, index) {
			elements.setAttribute( "autocomplete", "off" );
			elements.onfocus = function(){
				elements.parentElement.classList.add('focused');
			}
			elements.onblur = function(){
				if( elements.value != ''){}else{
					elements.parentElement.classList.remove('focused');
				}
			}
		});
		
	});

	$(window).on('load', function(){
		
		// Map: Return to previous page button. Change body id to match map template's name.
        if(document.querySelector("body#map") !== null) {
            const map_buttons = `
                <div class="return-from-map">
                    <a class="btn" href="javascript:history.back()" style="margin-right: 10px">Back to previous page</a>
                    <a class="btn" href="/explore/ada-map">View Accessible Map</a>
                </div>
            `;
            $('#content').prepend(map_buttons);
		}
		setTimeout(function(){
			$('.home__top-content__small img, .home__top-content__medium img').addClass('loadready');
		}, 500);
		
	});

}());